import { Component, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ListCustomCell } from '@shared/modules/list/interfaces/list-custom-cell.interface';
import { UIModule } from '@shared/modules/ui/ui.module';

@Component({
  selector: 'project-origin-cell',
  templateUrl: './project-origin-cell.component.html',
  standalone: true,
  imports: [UIModule, TranslateModule]
})
export class ProjectOriginCellComponent implements ListCustomCell {
  @ViewChild('template') template;
}
